import { pageInfo, exportData} from './../api';
import { Message } from 'element-ui';
import { plant, weighBusinessType } from '../../../../api'
const paymentDetail = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    updateResp: null,
    exportObj: [],
    businessTypeObj: null,
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    UPDATE_DATA(state, data){
      state.updateResp = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },

    WEIGH_BUSINESS_TYPE(state, data) {
      state.businessTypeObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async weighBusinessType({commit}, obj) {
      let resp = await weighBusinessType(obj);
      commit('WEIGH_BUSINESS_TYPE', resp);
    },
  }
}
export default paymentDetail



// WEBPACK FOOTER //
// ./src/page/report/paymentDetail/store/paymentDetail.store.js